import React, { useState, useEffect, useRef } from 'react';
import { Input, Button } from '@mui/material';
import { Modal } from 'react-bootstrap';
import { PuffLoader } from 'react-spinners';
import { Form, Col, Row } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { MDBDataTable } from 'mdbreact';
import moment from 'moment';
import StolenVehMap from './StolenVehMap';
import { GiCarDoor } from "react-icons/gi";
import ReactSwitch from 'react-switch';
import { MdAirlineSeatReclineExtra } from "react-icons/md";
import "./Monitor.css";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { IoIosSpeedometer } from "react-icons/io";
import { FaCarSide } from "react-icons/fa";
import { GrMapLocation } from "react-icons/gr";
import { FaLocationArrow } from "react-icons/fa";
import { GiCarWheel } from "react-icons/gi";
import { PiEngineFill } from "react-icons/pi";
import { FaInfoCircle  } from "react-icons/fa";
import html2canvas from 'html2canvas';
import { RiScreenshot2Fill } from "react-icons/ri";
import { RiDeleteBinFill } from "react-icons/ri";
import {FaEye} from "react-icons/fa6";


const Monitor = () => {
    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const [loading, setLoading] = useState(false);
    const [vinNumber, setVinNumber] = useState('');
    const [recordPresent, setRecordPresent] = useState(false)
    const [accessDetails, setAccessDetails] = useState([])
    const vinPattern = /^[A-HJ-NPR-Z0-9]{17}$/; 
    const [fleetMonitorList, setFleetMonitorList] = useState([])
    const [selectMonitorType, setSelectMonitorType] = useState('one_vehicle');
    const dataToSend = { location: 'all', vehicle: selectMonitorType };
    const [geofenceCoordinates, setGeofenceCoordinates] = useState([])
    const [selectedVehicleInfo, setSelectedVehicleInfo] = useState('');
    const [isDetailsClicked, setIsDetailsClicked] = useState(false);
    const [checked, setChecked] = useState(true);
    const [lockStatus, SetLockStatus] = useState('Un Locked')
    const [selectedAddress, setSelectedAddress] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [viewVinNumber, setViewVinNumber] = useState('')
    const rowRef = useRef(null);

    const convertedDateTime = (dateTime) => {
        return moment(dateTime).tz("US/Eastern").format("MM/DD/YYYY HH:mm")+' EST';
    }

    const handleChange = val => {
        setChecked(val)
        if(val == true){
          SetLockStatus('Un Locked')
        }else{
          SetLockStatus('Locked')
        }
    }

    const handleUnitType = (value, selected_unit) => {
        if(selected_unit == "Miles"){
          return (parseFloat(value) * 0.621371).toFixed(2);
        }else if(selected_unit == "Meter"){
          return (parseFloat(value) * 1000).toFixed(2);
        }else{
          return value
        }
    };

    const handleglType = (value, selected_gl) => {
        if(selected_gl == "Gallon"){
          return (parseFloat(value) * 0.264172).toFixed(2);
        }else{
          return value
        }
    };

    const fetchAddress = async (latitude, longitude) => {
        try {
          const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`);
          setSelectedAddress(response.data.display_name);
        } catch (error) {
          setSelectedAddress("");
        }
    };

    const carDetailsHandle = (e) => {
        setSelectMonitorType('geofence')
    }

    const data = {
        columns: [{ label: 'S.No', field: 'sl_no',},{ label: 'VIN', field: 'vin',},{ label: 'Added By', field: 'added_by',}, { label: 'Created DateTime (EST)',
                field: 'c_date',},{ label: 'Action',  field: 'action', } ],
        rows: accessDetails
    };

    const handleSubmitForm = () => {
        if(vinNumber.toString().trim() === ''){
        Swal.fire({icon: 'error',
                    text: 'Please enter VIN Number.'})
        return;
        }
        if (!vinPattern.test(vinNumber)) {
        Swal.fire({ icon: 'error', text: 'Please enter a valid VIN Number.' });
        return;
        }
        setLoading(true);
        axios.post(baseURL + "/add_vin_queue", {
        'vin': vinNumber.toString().trim(),
        'admin_id': foundUser['tm_id']
        }).then((res) => {
            setLoading(false);
            setRecordPresent(true)
            if (res.data.msg_status == 1){
            Swal.fire({icon: 'success',
                title: res.data.msg
            })
            setVinNumber('');
            vinQueueData()
            }else{
            Swal.fire({icon: 'error',
                title: res.data.msg
            })
            }
        })
    }

    const handleViewDetails = (value, details) => {
        setLoading(true);
        setFleetMonitorList([])
        setGeofenceCoordinates([])
        const vin = details['vin']
        const loc_id = details['location_id']
        axios.get(baseURL + "/get_geofence_state?loc_id="+loc_id).then((res) => {
            setGeofenceCoordinates(res.data)
        });
        axios.get(baseURL + "/update_view_status?vin="+vin).then((res) => {
            vinQueueData();
        });
        axios.get(baseURL + "/get_vehicle_lastes_data?id="+value).then((res) => {
            if (res.data.status == '1'){
                setLoading(false);
                setIsDetailsClicked(true)
                setShowModal(false)
                const filteredData = res.data.data.filter(item => item.vin_number === vin);
                fetchAddress(filteredData[0].tele_data.geolocation.latitude, filteredData[0].tele_data.geolocation.longitude);
                setSelectedVehicleInfo(filteredData);
                setFleetMonitorList(res.data.data)
                setViewVinNumber(vin)
            }else{
                setLoading(false);
                setIsDetailsClicked(false)
                setFleetMonitorList([])
            }
        });
     
    }

    const deleteVin = (vin) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this VIN?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then(async (result)  => {
            if (result.isConfirmed) {
                axios.get(baseURL + "/delete_queue_vin?vin="+vin).then((res) => {
                    if(res.data == "success")
                    {
                        setShowModal(false)
                        vinQueueData()
                        Swal.fire({icon: 'success',
                            title: 'VIN Deleted Successfully.'
                        })
                    }
                });
            }
        })
    }

    const handleViewQueueButton = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    useEffect(() => {
        vinQueueData();
    },[]);

    const vinQueueData = () => {
        setLoading(true);
        axios.get(baseURL + "/get_all_vin_queue").then((res) => {
            var j = 1;
            setLoading(false);
            if(res.data.status === '1'){
                setRecordPresent(true)
                let rowsData = [];
                const myDataSet = res.data.data;
                for (var index = 0; index < res.data.data.length; index++) {
                    let rowItem = {};
                    const val = myDataSet[index];
                    let btnColor = ''
                    if(val['viewed'] == 'no'){ 
                        btnColor = 'blue'; 
                    }
                    else{ 
                        btnColor = 'black'; 
                    }
                    rowItem["sl_no"] = j;
                    rowItem["vin"] = val['vin'];
                    rowItem["added_by"] = val['added_by'];
                    rowItem["c_date"] = moment(new Date(val.created_datetime)).tz("US/Eastern").format('MM/DD/YYYY hh:mm A');
                    rowItem['action'] = (<React.Fragment>
                        <FaInfoCircle   title='View' onClick={(e) => handleViewDetails(val.sl_no,val)} style={{ marginLeft: '8px', cursor: 'pointer', color:btnColor }}/>
                        <RiDeleteBinFill  title='Delete' onClick={() => deleteVin(val['vin'])} style={{ cursor: 'pointer',color:'red' }}/>
                        </React.Fragment>)
                    rowsData.push(rowItem)
                    j++;
                }
                setAccessDetails(rowsData);
            }
            else
            {
                setAccessDetails([]);
            }
        })
    }

    const handleScreenshot = async () => {
        const vinNumber = selectedVehicleInfo[0].vin_number
        const rowElement = rowRef.current;
        html2canvas(rowElement, {
            useCORS: true,
            scrollX: 0,
            scrollY: 0,
            windowWidth: document.documentElement.scrollWidth,
            windowHeight: document.documentElement.scrollHeight,
            x: rowElement.scrollLeft,
            y: rowElement.scrollTop,
            width: rowElement.scrollWidth,
            height: rowElement.scrollHeight,
            scale: window.devicePixelRatio // To handle high DPI screens
        }).then(rowCanvas => {
            const url = rowCanvas.toDataURL();
            const link = document.createElement('a');
            link.href = url;
            link.download = `${vinNumber}.png`; 
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
      };

    return(
        <div className='body_class'>
            {loading ? (
                <div className="loader-overlay">
                    <div className="loader">
                    <PuffLoader color="#00308F" loading={true} size={200} />
                    </div>
                </div>
            ) : ("")}
            <h4 style={{marginLeft:"3px"}}>Vehicle Queue</h4>
            <div className='row p-4'>
                <div className='col-auto mt-1'>
                    <label className='form-label'>VIN Number *</label>
                </div>
                <div className='col-3'>
                    <input
                        type='text'
                        className='form-control'
                        value={vinNumber}
                        onChange={(e) => setVinNumber(e.target.value)}
                        placeholder='Enter VIN Number'
                    />
                </div>
                <div className='col-2'>
                        <Button
                            variant="contained"
                            onClick={handleSubmitForm}
                        >
                            <FaPlus />&nbsp;Add
                        </Button>
                    {/* </div> */}
                </div>
                <div className='col-4'>
                    {recordPresent &&
                        <Button
                            variant="contained"
                            className='ms-2'
                            onClick={handleViewQueueButton}
                        >
                            <FaEye title='View'/>&nbsp;View Queue
                        </Button>
                    }
                </div>
                <Modal show={showModal} onHide={handleCloseModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Queue Data</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {recordPresent ? (
                            <MDBDataTable
                                bordered
                                data={data}
                                large={false}
                                displayEntries={false}
                                search={true}
                                noBottomColumns={true}
                                className="pagination-right-aligned"
                                searching={true}
                            />
                        ) : (
                            <p>No data available</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            {isDetailsClicked ?(
                <>
                <div style={{ display: "flex", justifyContent: "left", padding:"7px",marginLeft:"25px"}}>
                    <label style={{fontWeight:"bold"}}>VIN: {viewVinNumber}</label>
                </div>
                <div style={{ display: "flex", justifyContent: "right", marginTop:"-44px", padding:"7px",marginRight:"20px"}}>
                    <Button size='small' variant="contained" onClick={handleScreenshot}>
                    <RiScreenshot2Fill size={25}/>&nbsp;Take Screenshot
                    </Button>
                </div>
                <div className='p-1 madatory_fields custom_monitor_screen'>
                    <div className='row' style={{minHeight:"87vh"}} ref={rowRef}>
                        <div className='col-3 car_details' style={{maxHeight:"87vh",overflowY:"auto"}}>
                            <div className='row'>
                                <div className='col-10 pt-2'>
                                <h5>Details</h5>
                                </div>
                                <div className='col-1 pt-1'>
                                <h5 className='pointer' onClick={carDetailsHandle}>X</h5>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <label style={{float:"right"}}>Last Updated: <span style={{color:"red"}}>{convertedDateTime(selectedVehicleInfo[0].tele_data.datetimeSending)}</span></label>
                                </div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-12'>
                                    <div className="fw-bold">Status : <lable style={{color:"#e319e3",fontSize:"20px"}}>{(selectedVehicleInfo[0].tele_data.status)?selectedVehicleInfo[0].tele_data.status.value:"N/A"}</lable></div>
                                    <p className="fw-bold">{selectedVehicleInfo[0].make} {selectedVehicleInfo[0].model}</p>
                                    <div><lable className="fw-bold">Vin : </lable>{selectedVehicleInfo[0].vin_number}</div>
                                    <div><lable className="fw-bold">Plate : </lable>{selectedVehicleInfo[0].plate}</div>
                                    <div><lable className="fw-bold">R/A : </lable>{(selectedVehicleInfo[0].agreement_number)?selectedVehicleInfo[0].agreement_number:""}</div>
                                    <div style={{color:selectedVehicleInfo[0].agreement_type === 'In Agreement'?'green':'grey',float:"right"}}><lable className="fw-bold">{selectedVehicleInfo[0].agreement_type}</lable></div>
                                </div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-12'>
                                    <span className="fw-bold"><GiCarWheel style={{width:"25px",height:"25px"}}/>Tire Pressure</span>
                                </div>
                                <div className='col-6'>Front(L): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.left)?selectedVehicleInfo[0].tele_data.tirePressure.front.left.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.left)?selectedVehicleInfo[0].tele_data.tirePressure.front.left.unit:""}</b></div>
                                <div className='col-6'>Front(R): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.right)?selectedVehicleInfo[0].tele_data.tirePressure.front.right.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.right)?selectedVehicleInfo[0].tele_data.tirePressure.front.right.unit:""}</b></div>
                                <div className='col-6'>Rear(L): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.left)?selectedVehicleInfo[0].tele_data.tirePressure.rear.left.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.left)?selectedVehicleInfo[0].tele_data.tirePressure.rear.left.unit:""}</b></div>
                                <div className='col-6'>Rear(R): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.right)?selectedVehicleInfo[0].tele_data.tirePressure.rear.right.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.right)?selectedVehicleInfo[0].tele_data.tirePressure.rear.right.unit:""}</b></div>
                                <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.left)?convertedDateTime(selectedVehicleInfo[0].tele_data.tirePressure.front.left.datetime):""}</b></div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-6'>
                                <span className="fw-bold"><PiEngineFill style={{width:"25px",height:"25px"}}/>Engine</span>
                                </div>
                                <div className='col-6'>
                                <span className="fw-bold" style={{color:"#e319e3"}}>{(selectedVehicleInfo[0].tele_data.engine.status)?selectedVehicleInfo[0].tele_data.engine.status.value:"N/A"}</span>
                                </div>
                                <div className='col-6'>
                          battery: 
                          <b>
                            {(selectedVehicleInfo[0].tele_data.engine.battery && selectedVehicleInfo[0].tele_data.engine.battery.voltage) 
                              ? selectedVehicleInfo[0].tele_data.engine.battery.voltage.value : ""}
                            {(selectedVehicleInfo[0].tele_data.engine.battery && selectedVehicleInfo[0].tele_data.engine.battery.voltage) 
                              ? selectedVehicleInfo[0].tele_data.engine.battery.voltage.unit : ""}
                          </b>
                        </div>
                        <div className='col-6'>
                          coolant: 
                          <b>
                            {(selectedVehicleInfo[0].tele_data.engine.coolant && selectedVehicleInfo[0].tele_data.engine.coolant.temperature) 
                              ? selectedVehicleInfo[0].tele_data.engine.coolant.temperature.value : ""}
                            {(selectedVehicleInfo[0].tele_data.engine.coolant && selectedVehicleInfo[0].tele_data.engine.coolant.temperature) 
                              ? selectedVehicleInfo[0].tele_data.engine.coolant.temperature.unit : ""}
                          </b>
                        </div>
                        <div className='col-12'>
                          speed: 
                          <b>
                            {(selectedVehicleInfo[0].tele_data.engine.speed) 
                              ? selectedVehicleInfo[0].tele_data.engine.speed.value : ""}
                            {(selectedVehicleInfo[0].tele_data.engine.speed) 
                              ? selectedVehicleInfo[0].tele_data.engine.speed.unit : ""}
                          </b>
                        </div>
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>{(selectedVehicleInfo[0].tele_data.engine.status)?convertedDateTime(selectedVehicleInfo[0].tele_data.engine.status.datetime):""}</b></div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-8'>
                                <p className="fw-bold"><GrMapLocation /> Location Details</p>
                                </div>
                                <div className='col-12'><p style={{marginLeft:"15px"}}><FaLocationArrow /> {selectedAddress}</p></div>
                                <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>{(selectedVehicleInfo[0].tele_data.geolocation)?convertedDateTime(selectedVehicleInfo[0].tele_data.geolocation.datetime):""}</b></div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-8'>
                                <p className="fw-bold">Additional Info</p>
                                </div>
                                <div className='col-12'><FaCarSide /> Vehicle Moving: <b>{(selectedVehicleInfo[0].tele_data.moving && selectedVehicleInfo[0].tele_data.moving.value)?"Yes":"No"}</b></div>
                                <div className='col-12'><IoIosSpeedometer /> Speed: <b>{(selectedVehicleInfo[0].tele_data.speed)?handleUnitType(selectedVehicleInfo[0].tele_data.speed.value,selectedVehicleInfo[0].unit_type):"0"} {selectedVehicleInfo[0].unit_type}/h</b></div>
                                <div className='col-12'><IoIosSpeedometer /> Odometer: <b>{(selectedVehicleInfo[0].tele_data.odometer)?handleUnitType(selectedVehicleInfo[0].tele_data.odometer.value,selectedVehicleInfo[0].unit_type):""} {selectedVehicleInfo[0].unit_type}</b></div>
                                {/* <div className='col-12'><BsFillFuelPumpFill /> Fuel Level: <b>{(selectedVehicleInfo[0].tele_data.fuel)?handleglType(selectedVehicleInfo[0].tele_data.fuel.level.value,selectedVehicleInfo[0].gl_type):"0"} {selectedVehicleInfo[0].gl_type}</b></div> */}
                                <div className='col-12'><BsFillFuelPumpFill /> Fuel Level: <b>
                                    {/* {selectedVehicleInfo?.[0]?.tele_data?.fuel?.level?.percentage ? selectedVehicleInfo[0].tele_data.fuel.level.percentage + " %" : "N/A"} */}
                                    {selectedVehicleInfo[0].tele_data.fuel &&
                                    (
                                        (selectedVehicleInfo[0].tele_data.fuel.level && selectedVehicleInfo[0].tele_data.fuel.level.percentage) 
                                        ? selectedVehicleInfo[0].tele_data.fuel.level.percentage + " %"
                                        : selectedVehicleInfo[0].tele_data.fuel.percentage 
                                            ? selectedVehicleInfo[0].tele_data.fuel.percentage + " %"
                                            : "N/A"
                                    )}
                                    </b>
                                </div>
                                <div className='col-12'><BsFillFuelPumpFill /> Fuel Residual Autonomy: <b>{(selectedVehicleInfo[0].tele_data.fuel && selectedVehicleInfo[0].tele_data.fuel.residualAutonomy)?handleUnitType(selectedVehicleInfo[0].tele_data.fuel.residualAutonomy.value,selectedVehicleInfo[0].unit_type):"0"} {selectedVehicleInfo[0].unit_type}</b></div>
                                <div className='col-12'><MdAirlineSeatReclineExtra /> Driver Seatbelt Wearing: <b>{(selectedVehicleInfo[0].tele_data.seatbelt && selectedVehicleInfo[0].tele_data.seatbelt.driver && selectedVehicleInfo[0].tele_data.seatbelt.driver.value)?"Yes":"No"}</b></div>
                                <div className='col-12'><GiCarDoor /> Doors Locked: <b>{(selectedVehicleInfo[0].tele_data.doors && selectedVehicleInfo[0].tele_data.doors.locked && selectedVehicleInfo[0].tele_data.doors.locked.value)?"Yes":"No"}</b></div>
                                <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>{(selectedVehicleInfo[0].tele_data.odometer)?convertedDateTime(selectedVehicleInfo[0].tele_data.odometer.datetime):""}</b></div>
                            </div>
                            <hr />
                            <div className='row'>
                                <div className='col-8'>
                                <p className="fw-bold">Control Vehicle</p>
                                </div>
                                <div className='col-4'>
                                <p className="fw-bold">{lockStatus}</p>
                                </div>
                                <div className='col-12 l-3 d-flex justify-content-center'>
                                    <label htmlFor="my-switch">Lock &nbsp;</label>
                                    <ReactSwitch
                                        checked={checked}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="my-switch" className="ml-2">&nbsp; Un Lock</label>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className='col-9'>
                            {fleetMonitorList.length > 0 && geofenceCoordinates.state?
                            <div className='row'>
                            <StolenVehMap 
                                key={JSON.stringify(dataToSend)} 
                                dataToSend={dataToSend} 
                                geofenceCoordinates={geofenceCoordinates} 
                                teleStatus={fleetMonitorList} 
                                selectedVehicle={selectedVehicleInfo}/>
                            </div>
                            :<h3 className='text-center mt-4' style={{color:"red"}}>No Data / Please select a VIN</h3>}
                        </div>
                    </div>
                </div>
                </>
            ):
            ('')
            }
        </div>
    )
}

export default Monitor;